import styled from "styled-components"

export default styled.label`
  margin-bottom: 5px;
  font-weight: bold;
`
